
import type { UploadedFile, Question, QuestionType, QuestionDifficulty, Book, Member, Transaction } from '../../services/types';

export const SUBJECT_OPTIONS = ['Mathematics', 'English', 'Kiswahili', 'Biology', 'Chemistry', 'Physics', 'History', 'Geography', 'CRE', 'Business Studies'];
export const GRADE_OPTIONS = ['Form 1', 'Form 2', 'Form 3', 'Form 4'];
export const YEAR_OPTIONS = ['2023', '2022', '2021', '2020'];
export const DIFFICULTY_OPTIONS: QuestionDifficulty[] = ['Easy', 'Medium', 'Hard'];
// fix(constants): Export TYPE_OPTIONS for use in question bank filters.
export const TYPE_OPTIONS: QuestionType[] = ['MCQ', 'Short Answer', 'Essay', 'Mix'];
export const NUM_QUESTIONS_OPTIONS = [5, 10, 15, 20];
export const EXAM_TYPE_OPTIONS = ['CAT 1', 'CAT 2', 'Main Exam', 'Random Assessment Test', 'Custom'];


export const initialFiles: UploadedFile[] = [
    { id: '1', name: 'calculus-form4-exam.pdf', subject: 'Mathematics', grade: 'Form 4', year: '2022', topic: 'Calculus', status: 'processed' },
    { id: '2', name: 'betrayal-in-the-city.docx', subject: 'English', grade: 'Form 3', year: '2023', topic: 'Play Analysis', status: 'processed' },
    { id: '3', name: 'mitosis-notes.txt', subject: 'Biology', grade: 'Form 2', year: '2023', topic: 'Cell Division', status: 'uploaded' },
];

export const initialQuestions: Question[] = [
    {
      id: 'q1',
      section: 'Section A',
      subject: 'Mathematics',
      grade: 'Form 4',
      topic: 'Calculus',
      question: 'What is the integral of 2x with respect to x?',
      type: 'Short Answer',
      marks: 5,
      difficulty: 'Easy',
      answer: 'x^2 + C',
      explanation: 'The power rule of integration states that the integral of x^n is (x^(n+1))/(n+1). Here, n=1, so the integral is (2 * x^2)/2 + C, which simplifies to x^2 + C.'
    },
    {
      id: 'q2',
      section: 'Section B',
      subject: 'English',
      grade: 'Form 3',
      topic: 'Play Analysis',
      question: 'In the play "Betrayal in the City", what is the main theme?',
      type: 'MCQ',
      marks: 10,
      difficulty: 'Medium',
      answer: 'The corrupting influence of power and the subsequent betrayal of post-independence ideals.',
      explanation: 'The play explores how the new leadership in Kafira betrays the hopes and dreams of its citizens after gaining independence, leading to oppression and disillusionment.'
    }
];

// --- New Library Data ---
export const BOOK_CATEGORY_OPTIONS = ["Fiction", "Non-Fiction", "Science", "History", "Biography", "Technology", "Arts"];

export const initialBooks: Book[] = [
  { id: 'book-1', title: 'The River and the Source', author: 'Margaret A. Ogola', isbn: '978-9966466952', category: 'Fiction', shelfLocation: 'A1', quantity: 5, available: 3, status: 'Available', description: 'A classic Kenyan novel spanning four generations of women.' },
  { id: 'book-2', title: 'A Doll\'s House', author: 'Henrik Ibsen', isbn: '978-0486270623', category: 'Play', shelfLocation: 'B3', quantity: 3, available: 0, status: 'Borrowed', description: 'A landmark 19th-century play exploring marriage and societal norms.' },
  { id: 'book-3', title: 'Calculus: A First Course', author: 'Serge Lang', isbn: '978-0387962016', category: 'Mathematics', shelfLocation: 'C2', quantity: 10, available: 10, status: 'Available', description: 'An introductory textbook on single-variable calculus.' },
  { id: 'book-4', title: 'Blossoms of the Savannah', author: 'Henry Ole Kulet', isbn: '978-9966345980', category: 'Fiction', shelfLocation: 'A2', quantity: 7, available: 7, status: 'Available', description: 'Explores the clash between tradition and modernity through the lives of two sisters.' },
];

export const initialMembers: Member[] = [
  { id: 'member-1', name: 'John Doe', email: 'john.doe@example.com', memberId: 'S001', role: 'Student' },
  { id: 'member-2', name: 'Jane Smith', email: 'jane.smith@example.com', memberId: 'T001', role: 'Staff' },
  { id: 'member-3', name: 'Peter Jones', email: 'peter.jones@example.com', memberId: 'S002', role: 'Student' },
];

const now = new Date();
const tenDaysAgo = new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000);
const fiveDaysAgo = new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000);
const fourDaysFromNow = new Date(now.getTime() + 4 * 24 * 60 * 60 * 1000);
const nineDaysFromNow = new Date(now.getTime() + 9 * 24 * 60 * 60 * 1000);

export const initialTransactions: Transaction[] = [
  { id: 'trans-1', bookId: 'book-2', bookTitle: 'A Doll\'s House', memberId: 'member-1', memberName: 'John Doe', type: 'Borrow', date: tenDaysAgo.toISOString(), dueDate: fourDaysFromNow.toISOString() },
  { id: 'trans-2', bookId: 'book-2', bookTitle: 'A Doll\'s House', memberId: 'member-2', memberName: 'Jane Smith', type: 'Borrow', date: fiveDaysAgo.toISOString(), dueDate: nineDaysFromNow.toISOString() },
];